import { CalendarMonth, Favorite, Language, LocalOffer, Person, Place, PriorityHigh, Search, Share, Work } from "@mui/icons-material";
import moment from "moment";
import platforms from "./platforms";
import priorities from "./priorities";
import languages from "./languages";
import sentiments from "./sentiments";
import { intervalLabel } from "../common";

const postfilters = {
    interval: {
        icon: CalendarMonth,
        label: filter => {
            return "Last " + intervalLabel(filter)
        }
    },
    date: {
        icon: CalendarMonth,
        label: filter => {
            let string = "";
            if(filter.start)
                string += " from " + moment(filter.start).format("LL");
            if(filter.end){
                string += " to " + moment(filter.end).format("LL");
            }
            return string.trim();
        }
    },
    
    text_search: {
        icon: Search,
        label: filter => filter
    },
    sentiment: {
        icon: Favorite,
        label: filter => sentiments[filter]
    },
    language: {
        icon: Language,
        label: filter => languages[filter]
    },
    tag: {
        icon: LocalOffer,
        label: (filter, project) => {
            if(filter.value && filter.value[0]==="9999" ){
                return "Posts without tags";
            }
            if(!project || !project.tags){
                return "";
            }
            let joinString = ", ";
            let initialString = "";
            switch(filter.operator){
                case 'and': joinString = " and "; break;
                case 'not': initialString = "not "; joinString = " and not "; break;
                case 'notstrict': initialString = "not "; joinString = " or not "; break;
                case 'default':
                default: joinString = " or "; break;
            }
            return <>
                {initialString} {filter.value
                .map(id => project.tags.find(t => t.id === id).label)
                .map(t => <b>{t}</b>)
                .reduce((prev, curr) => [prev, joinString, curr])}
            </>
        }
    },
    priority: {
        icon: PriorityHigh,
        label: filter => priorities[filter]
    },
    author: {
        icon: Person,
        label: filter => filter
    },
    platform: {
        icon: Share,
        label: filter => platforms[filter]
    },
    job: {
        icon: Work,
        label: (filter, project) => {
            if (!project || !project.jobs || !filter?.value) {
                return "";
            }
            let joinString = " or ";
            let initialString = "";
            
            // Simplified logic for jobs - only OR and NOT make sense
            switch(filter.operator){
                case 'not': initialString = "not "; break;
                case 'default':
                default: break; // no prefix for default OR operation
            }
            
            const jobLabels = filter.value
                .map(id => {
                    const job = project.jobs.find(j => j.id === id);
                    return job ? job.label : `Job ${id}`;
                })
                .filter(Boolean);
                
            if (jobLabels.length === 0) return "";
            
            // For single job, don't show "or"
            if (jobLabels.length === 1) {
                return <>
                    {initialString}<b>{jobLabels[0]}</b>
                </>
            }
            
            return <>
                {initialString} {jobLabels
                .map(label => <b key={label}>{label}</b>)
                .reduce((prev, curr) => [prev, joinString, curr])}
            </>
        }
    },
    geo: {
        icon: Place,
        label: (filter) => {
            if (!filter) return "Geo";

            if ((filter.mode || "name") === "distance") {
                const radius = filter.distance && filter.distance.radiusKm ? filter.distance.radiusKm : 25;
                const center = filter.distance && filter.distance.center ? filter.distance.center : null;
                if (center && (center.label || (center.lat != null && center.lon != null))) {
                    const label = center.label || `${center.lat}, ${center.lon}`;
                    return `${label} • ${radius}km`;
                }
                return `Within ${radius}km`;
            }

            const nameNode = filter.name || {};
            const places = Array.isArray(nameNode.places) ? nameNode.places : [];
            const countries = Array.isArray(nameNode.countries) ? nameNode.countries : [];
            const op = (nameNode.op || "OR").toUpperCase() === "AND" ? "AND" : "OR";

            if (!places.length && !countries.length) {
                return "Geo";
            }

            const tokens = [];
            if (places.length === 1) tokens.push(places[0]);
            if (places.length > 1) tokens.push(`${places.length} places`);
            if (countries.length === 1) tokens.push(countries[0]);
            if (countries.length > 1) tokens.push(`${countries.length} countries`);

            return tokens.join(` ${op} `);
        }
    }
};

export default postfilters;